import React from 'react';
import {Box, CircularProgress} from '@deere/fuel-react';

export const Loading = () => {
    return (
        <Box
            display='flex'
            justifyContent='center'
            m={1}
        >
            <Box p={3}>
                <CircularProgress
                    size='lg'
                    variant='indeterminate'
                    style={{color:"green"}}
                />
            </Box>
        </Box>
    );
}
export const Loading2 = () => {
    return (
        <Box
            display='flex'
            justifyContent='center'
            m={1}
        >
            
                < CircularProgress
                    
                    size='sm'
                    variant='indeterminate'
                    style={{color:"green"}}
                />
            
        </Box>
    );
}
